"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("highchartFullscreenPopinController", function ($scope, highchartUtils) {
  var originalChart = $scope.originalChart;
  var initialExportedChartConfig = highchartUtils.copyChartConfigForPopins(originalChart);
  function prepareChartConfig() {
    var chartConfig = angular.copy(initialExportedChartConfig);

    // this remove the highchart navigator for highstock charts
    chartConfig.series = _.filter(chartConfig.series, function (serie) {
      return serie.id !== "highcharts-navigator-series";
    });

    // Surcharge les options avec d'éventuelles options fullScreen
    if (originalChart.fsOptions) {
      chartConfig.options = _objectSpread({}, chartConfig.options, {}, originalChart.fsOptions);
    }
    /*
    chartConfig.options = {
        ...chartConfig.options,
        navigator : {
            enabled : false
        },
        scrollbar : {
            enabled : false
        },
        rangeSelector : {
            enabled : false
        }
    };
    */

    return chartConfig;
  }
  $scope.fullscreenChartConfig = prepareChartConfig();

  // fix highchart autoscale due to transition on popin
  _.delay(function () {
    $scope.$broadcast("$resize");
    $scope.$apply();
  }, 200);
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/full-screen/highchartFullscreenPopin.js
// module id = 2960
// module chunks = 13